import { API_BASE_URL } from "./utils";

export const WHITE_LABELING_QUERY_KEY = ["admin", "white-labeling"];

export function resolveCompanyMediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const origin = API_BASE_URL.replace(/\/api\/v1$/, "");
  return `${origin}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function formFromWhiteLabeling(wl = {}) {
  return {
    clinic_name: wl.clinic_name || "",
    clinic_logo: wl.clinic_logo || "",
    clinic_address: wl.clinic_address || "",
    country: wl.country || "",
    city: wl.city || "",
    website: wl.website || "",
    business_phone: wl.business_phone || "",
    business_email: wl.business_email || "",
    public_contact_details: Boolean(wl.public_contact_details),
  };
}

/** Sidebar/header brand: clinic white-label when set, else platform branding. */
export function companyAdminDisplayBrand(company, branding) {
  const wl = company?.white_labeling || {};
  const name = String(wl.clinic_name || "").trim();
  const logo = String(wl.clinic_logo || "").trim();
  if (name || logo) {
    return {
      name: name || branding?.brand_name || company?.name || "DietCoach",
      logoSrc: resolveCompanyMediaUrl(logo) || "",
    };
  }
  return {
    name: branding?.brand_name || company?.name || "DietCoach",
    logoSrc: "",
  };
}
